import {APP_NAME} from '../brand';

// Because there are all brand names, it is unnecessary for them to be translatable.
export default [
    {tag: 'ws', intlLabel: 'DANVworkshop'},
    {tag: 'scratch', intlLabel: 'Scratch'},
    {tag: 'tw', intlLabel: 'TurboWarp'},
    {tag: 'ac', intlLabel: APP_NAME}
];